
import CreditBackTableView from "@/views/CreditBack/ItemView/TableView.vue";
import CreditBackBlockView from "@/views/CreditBack/ItemView/BlockView.vue";
import creditbackApi from "@/api/creditbackApi";
import { EXECUTE_RESULT } from "@/constant/baseConstant";

const creditbackHistoryOrderByEnum = {
    CREATED_AT:  1,
    ID:  2,
}

export default {
    components: {
        CreditBackTableView,
        CreditBackBlockView
    },
    data() {
        return {
            creditbackHistoryOrderByEnum,
            pagination: {
                PageIndex: 1,
                PageSize: 50,
                DirectionSort: "DESC",
                OrderBy: creditbackHistoryOrderByEnum.CREATED_AT
            },
            items: [],
            totalRows: 0,
            totalPointBack: 0,
        };
    },
    mounted() {
        this.creditbackHistoryView();
        this.creditbackTotalPointBack();
    },
    methods: {
        async creditbackHistoryView() {
            const res = await creditbackApi.creditbackHistoryView(this.pagination);
            if(res){
                const data = res.data;
                if(data.result === EXECUTE_RESULT.SUCCESS){
                    this.items = data.data.data;
                    this.totalRows = data.data.pagingItem.outRowsNumber
                }
            }
        },
        async creditbackTotalPointBack() {
            const res = await creditbackApi.creditbackTotalPointBack();
            if(res){
                const data = res.data;
                if(data.result === EXECUTE_RESULT.SUCCESS){
                    this.totalPointBack = data.data;
                }
            }
        },
        
        // Sort list
        sortList(element) {
            this.pagination.pageIndex = 1;
            this.pagination.orderBy = element;
            if (this.pagination.directionSort === 'ASC') {
                this.pagination.directionSort = 'DESC'
            } else {
                this.pagination.directionSort = 'ASC'
            }
            this.creditbackHistoryView();
        },

        // Pagination size change
        handleSizeChange(pageSize) {
            this.pagination.pageIndex = 1;
            this.pagination.pageSize = pageSize;
            this.creditbackHistoryView();
        },

        // Pagination page change
        handleCurrentChange(element) {
            this.pagination.pageIndex = element;
            this.creditbackHistoryView();
        },
    }
}